import Constants from 'client/util/Constants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const getRecipe = (connectKey, kickstart) => {
  const content = `package 'curl'
  package 'sudo'
  package 'bash'
  execute 'agent_install' do
    command "curl --tlsv1.2 --silent --show-error --header 'x-connect-key: ${connectKey}' '${kickstart}' | sudo bash"
    path [ '/sbin', '/bin', '/usr/sbin', '/usr/bin' ]
    timeout 600
    creates '/opt/jc'
  end
  `;

  return {
    content,
    rows: content.match(/\n/g).length + 3,
  };
};

const getManifest = (connectKey, kickstart) => {
  const content = `package { 'agent_dependency_curl' :
    ensure => present,
    name   => 'curl'
  } ->
  package { 'agent_dependency_sudo' :
    ensure => present,
    name   => 'sudo'
  } ->
  package { 'agent_dependency_bash' :
    ensure => present,
    name   => 'bash'
  } ->
  exec { 'agent_install' :
    command => "curl --tlsv1.2 --silent --show-error --header 'x-connect-key: ${connectKey}' '${kickstart}' | sudo bash",
    path    => [ '/sbin', '/bin', '/usr/sbin', '/usr/bin' ],
    timeout => 600,
    creates => '/opt/jc'
  }
  `;

  return {
    content,
    rows: content.match(/\n/g).length + 3,
  };
};

export default {
  props: {
    connectKey: {
      type: String,
      required: true,
    },
    kickstart: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      copyWellLinux: {
        content: `curl --tlsv1.2 --silent --show-error --header 'x-connect-key: ${this.connectKey}' ${this.kickstart} | sudo bash`,
        label: 'Install Command',
        rows: 3,
      },
      copyWellPowershell: {
        content: `cd $env:temp | Invoke-Expression; Invoke-RestMethod -Method Get -URI https://raw.githubusercontent.com/TheJumpCloud/support/master/scripts/windows/InstallWindowsAgent.ps1 -OutFile InstallWindowsAgent.ps1 | Invoke-Expression; ./InstallWindowsAgent.ps1 -JumpCloudConnectKey "${this.connectKey}"`,
        label: 'PowerShell Install Command',
        rows: 7,
      },
      copyWellTerminal: {
        content: `curl -s https://raw.githubusercontent.com/TheJumpCloud/support/master/scripts/macos/install_agent_and_serviceaccount.sh -o $TMPDIR/install_agent_and_serviceaccount.sh && sudo bash $TMPDIR/install_agent_and_serviceaccount.sh -k ${this.connectKey} && rm $TMPDIR/install_agent_and_serviceaccount.sh`,
        label: 'Terminal Install Command',
        rows: 4,
      },
      kbLink: {
        href: KbArticleUrls.agentCompatibilityAndRequirements,
        text: 'Learn more',
      },
    };
  },

  computed: {
    copyWellChef() {
      const { content, rows } = getRecipe(this.connectKey, this.kickstart);

      return {
        content,
        label: 'Recipe',
        rows,
      };
    },

    copyWellPuppet() {
      const { content, rows } = getManifest(this.connectKey, this.kickstart);

      return {
        content,
        label: 'Manifest',
        rows,
      };
    },
  },

  methods: {
    triggerClickAgentButtonEvent(os) {
      EventHelper.triggerSystemsDownloadAgentButtonClicked({ os: Constants[os] });
    },
  },
};
